/* Sneyzen BROUILLON « arrondi » : petites animations et aides au parcours (chargé en defer, sans dépendance).
   - apparition douce des cartes, textes et images quand on fait défiler (seulement sous la ligne de flottaison)
   - « Lire la suite » sur les longues intros de collection (téléphone)
   - titres d'accordéons en majuscules remis en minuscules lisibles
   - espaces insécables à la française avant ? ! : ; dans les titres
   - petit rebond du panier quand on ajoute un produit
   Tout respecte « réduire les animations » du téléphone. */
(function () {
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.getElementById('MainContent');
  if (!main) return;
  var tpl = main.getAttribute('data-template') || '';

  /* 1. Apparition au défilement */
  if (!still && 'IntersectionObserver' in window) {
    var sel = '.product-grid__item, .resource-list__item, .image-block, .group-block > .group-block-content > .text-block, accordion-custom, .sz-rv__card, .collection-card';
    var vh = window.innerHeight;
    var items = Array.prototype.filter.call(main.querySelectorAll(sel), function (el) {
      if (el.closest('.szx, .szr, .szc, .szab, .szf, .sza, .szd, dialog')) return false;
      return el.getBoundingClientRect().top > vh * 0.9;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    items.forEach(function (el) {
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--sz-d', (sib % 4) * 70 + 'ms');
      el.classList.add('sz-rv');
      io.observe(el);
    });
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 7000);
  }

  /* 2. « Lire la suite » sur les intros de collection (téléphone) */
  if (/^collection/.test(tpl) && window.innerWidth < 750) {
    main.querySelectorAll('.hero .text-block').forEach(function (b) {
      if (b.querySelector('h1') || b.scrollHeight < 120) return;
      b.classList.add('sz-clamp');
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'sz-more'; btn.textContent = 'Lire la suite ↓';
      btn.addEventListener('click', function () {
        var open = b.classList.toggle('is-open');
        btn.textContent = open ? 'Réduire ↑' : 'Lire la suite ↓';
      });
      b.insertAdjacentElement('afterend', btn);
    });
  }

  /* 3. Titres d'accordéons tapés en MAJUSCULES : remis en minuscules lisibles (« PUIS-JE VENDRE… » → « Puis-je vendre… ») */
  main.querySelectorAll('.accordion .details__header').forEach(function (h) {
    h.childNodes.forEach(function (n) {
      if (n.nodeType !== 3) return;
      var t = n.textContent, letters = t.replace(/[^A-Za-zÀ-ÿ]/g, '');
      if (letters.length < 6 || letters !== letters.toUpperCase()) return;
      var lo = t.toLowerCase().replace(/\s{2,}/g, ' ').replace(/\s+([?!:;])/g, ' $1');
      var i = lo.search(/[a-zà-ÿ]/);
      if (i > -1) n.textContent = lo.slice(0, i) + lo.charAt(i).toUpperCase() + lo.slice(i + 1);
    });
  });

  /* 4bis. Typographie française : espace insécable avant ? ! : ; » et après « dans les titres et boutons
     (le « ? » ne part plus tout seul à la ligne sur téléphone) */
  main.querySelectorAll('h1, h2, h3, summary, .details__header, button, .button, .szx__btn').forEach(function (el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (/ [?!:;»]|« /.test(v)) n.nodeValue = v.replace(/ ([?!:;»])/g, ' $1').replace(/« /g, '« ');
    }
  });

  /* 4. Le panier rebondit quand on ajoute un produit */
  function bump() {
    if (still) return;
    document.querySelectorAll('.header-actions__action[data-testid="cart-drawer-trigger"], cart-icon, .cart-bubble').forEach(function (el) {
      el.classList.remove('sz-bump'); void el.offsetWidth; el.classList.add('sz-bump');
    });
  }
  document.addEventListener('cart:update', bump);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) setTimeout(bump, 500);
  }, true);
})();
